export default __webpack_public_path__ + "static/media/91t.46f4aaf3.jpg";